var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        {
          staticStyle: { "margin-left": "16px" },
          attrs: { "align-baseline": "", wrap: "", "justify-start": "" }
        },
        [
          _c(
            "v-flex",
            {
              staticStyle: { "max-width": "637px" },
              attrs: { xs10: "", md7: "" }
            },
            [
              _c("v-text-field", {
                attrs: {
                  name: "input-1",
                  label: _vm.$t("tracking"),
                  id: "search",
                  title: _vm.$t("enterToSearch"),
                  value: _vm.barcode,
                  autofocus: ""
                },
                on: {
                  input: function(v) {
                    return (_vm.barcode = _vm.formateValue(v))
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchTrackingOTP.apply(null, arguments)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticStyle: { "margin-left": "2px" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { small: "", color: "primary" },
                  on: { click: _vm.searchTrackingOTP }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isWarehouse
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", [_vm._v(_vm._s(_vm.$t("addOTP")))]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticStyle: { "margin-top": "-40px" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "align-baseline": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md2: "", "mr-3": "" } },
                            [
                              _c("v-text-field", {
                                ref: "tracking",
                                staticClass: "required_field",
                                attrs: {
                                  label: _vm.$t("tracking"),
                                  rules: [_vm.fieldIsRequired("tracking")]
                                },
                                on: {
                                  input: function(v) {
                                    return (_vm.otpInEdit.tracking = _vm.formateValue(
                                      v
                                    ))
                                  }
                                },
                                model: {
                                  value: _vm.otpInEdit.tracking,
                                  callback: function($$v) {
                                    _vm.$set(_vm.otpInEdit, "tracking", $$v)
                                  },
                                  expression: "otpInEdit.tracking"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md3: "", "mr-3": "" } },
                            [
                              _c("v-text-field", {
                                ref: "otp",
                                staticClass: "required_field",
                                attrs: {
                                  label: _vm.$t("trackingOTPdesc"),
                                  rules: [_vm.fieldIsRequired("OTP")]
                                },
                                on: {
                                  input: function(v) {
                                    return (_vm.otpInEdit.otp = _vm.formateValue(
                                      v
                                    ))
                                  }
                                },
                                model: {
                                  value: _vm.otpInEdit.otp,
                                  callback: function($$v) {
                                    _vm.$set(_vm.otpInEdit, "otp", $$v)
                                  },
                                  expression: "otpInEdit.otp"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "", "mr-3": "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.$t("warehouse"),
                                  "item-text": "warehouseName",
                                  "item-value": "warehouseId",
                                  items: _vm.warehouseSite
                                },
                                model: {
                                  value: _vm.otpInEdit.warehouseKey,
                                  callback: function($$v) {
                                    _vm.$set(_vm.otpInEdit, "warehouseKey", $$v)
                                  },
                                  expression: "otpInEdit.warehouseKey"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "", "mr-3": "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "estimateDeliverDate",
                                  isShowIcon: false
                                },
                                model: {
                                  value: _vm.otpInEdit.estimateDeliverDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.otpInEdit,
                                      "estimateDeliverDate",
                                      $$v
                                    )
                                  },
                                  expression: "otpInEdit.estimateDeliverDate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    color: "primary",
                                    loading: _vm.isLoading
                                  },
                                  on: { click: _vm.onSubmit }
                                },
                                [_vm._v(_vm._s(_vm.$t("submit")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticStyle: { margin: "20px 0" } },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.downloadTemplate.apply(null, arguments)
                }
              }
            },
            [
              _c("v-icon", { attrs: { dark: "" } }, [_vm._v("cloud_download")]),
              _vm._v("\n      " + _vm._s(_vm.$t("downloadTemplate")) + "\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                title: "importFile",
                loading: _vm.isUploading
              }
            },
            [
              _c("v-icon", { attrs: { dark: "", left: "" } }, [
                _vm._v("cloud_upload")
              ]),
              _vm._v("\n      " + _vm._s(_vm.$t("batchUpload")) + "\n      "),
              _c("input", {
                staticClass: "hideInput",
                attrs: { type: "file", accept: ".csv,.xls,.xlsx" },
                on: {
                  click: _vm.clearSelectionCache,
                  change: _vm.uploadOtpFile
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.trackingOTPList,
                    pagination: _vm.pagination,
                    "rows-per-page-items": _vm.rowPerPage,
                    loading: _vm.loading
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.tracking) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _c(
                              "span",
                              {
                                style: {
                                  backgroundColor: props.item.isAbnormal
                                    ? "yellow"
                                    : ""
                                }
                              },
                              [_vm._v(_vm._s(props.item.otp))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.toDateYYYYMMDD(
                                    props.item.estimateDeliverDate
                                  )
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _vm.isWarehouse || props.item.isAbnormal
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { left: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(tooltip) {
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g({}, tooltip.on),
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          color: "primary",
                                                          flat: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleAbnormalOtp(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("warning")
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    props.item.note &&
                                                    props.item.isAbnormal
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t("note") +
                                                                  ": " +
                                                                  props.item
                                                                    .note
                                                              )
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.isWarehouse
                                              ? _vm.$t("reportAbnormalOtp")
                                              : _vm.$t("editAbnormalOtp")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("normal")) +
                                        "\n            "
                                    )
                                  ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("v-progress-linear", {
                    attrs: { color: "blue", indeterminate: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "progress",
                        fn: function() {
                          return undefined
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("abnormalOtp"),
          rightButtonText: _vm.$t("send"),
          rightMethod: _vm.sendAbnormalOtpMail
        },
        on: {
          popupClose: function($event) {
            _vm.isShowAbnormalOtpPopup = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("v-layout", { attrs: { "justify-start": "", "mb-2": "" } }, [
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("abnormalOtpNote")) +
                        "\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("v-textarea", {
                  attrs: {
                    label: _vm.$t("emailTemplate"),
                    disabled: true,
                    outline: ""
                  },
                  model: {
                    value: _vm.abnormalOtpNote,
                    callback: function($$v) {
                      _vm.abnormalOtpNote = $$v
                    },
                    expression: "abnormalOtpNote"
                  }
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  staticStyle: { "margin-top": "-10px" },
                  attrs: { label: _vm.$t("note") },
                  model: {
                    value: _vm.abnormalOtp.note,
                    callback: function($$v) {
                      _vm.$set(_vm.abnormalOtp, "note", $$v)
                    },
                    expression: "abnormalOtp.note"
                  }
                })
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.isShowAbnormalOtpPopup,
          callback: function($$v) {
            _vm.isShowAbnormalOtpPopup = $$v
          },
          expression: "isShowAbnormalOtpPopup"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d7128f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d7128f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrackingOTP.vue
// module id = null
// module chunks = 